<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'duplicate-documentation.add-documentation'">_Añadir documentos de otro concepto</span>
  </div>
  <!-- Contenedor -->
  <div class="duplicate-documentation__content-body">
    @switch (duplicateDocumentation.stepState) {
      @case ('init') {
        <div class="duplicate-documentation__form-1-step-container">
          <div class="duplicate-documentation__search-1-container">
            <p class="common-modal__content-header-info"
              [afTranslate]="'duplicate-documentation.text-init-1'">_Usa el buscador para localizar directamente los archivos...</p>
            <div class="common-search__container">
              <div class="common-search__container-tonal"
                [ngClass]="{'common-search__container-tonal--error': duplicateDocumentation.searchTextError}">
                <div class="common-search__container-input-text">
                  <input type="search"
                    class="common-search__input-text"
                    [(ngModel)]="duplicateDocumentation.searchText"
                    placeholder="{{'common.search-item' | afTranslate}}"
                    pAutoFocus
                    [autofocus]="duplicateDocumentation.stepState === 'init'"
                    (keydown.enter)="goToPressEnter($event)">
                </div>
                <div class="common-search__block-button-search">
                  @if(duplicateDocumentation.searchText){
                    <button class="common-button__icon-xs-noborder"
                      (click)="duplicateDocumentation.searchText = ''">
                      <i class="lf-icon-close-thick common-icon__sm"></i>
                    </button>
                  }
                  <div class="h-[22px]"
                    [ngClass]="duplicateDocumentation.searchText?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'"></div>
                  <button class="common-button__icon-sm-noborder"
                    (click)="goToSearch()"
                    [disabled]="!duplicateDocumentation.searchText">
                    <i class="lf-icon-search common-icon__md"></i>
                  </button>
                </div>
              </div>
              @if(duplicateDocumentation.searchTextError){
                <div class="common-search__container-error">
                  <span [afTranslate]="'common.required-3-characters'">_Es necesario introducir al menos 3 caracteres</span>
                </div>
              }
            </div>
          </div>
          <div class="duplicate-documentation__explore-1-container">
            <p class="common-modal__content-header-info"
              [afTranslate]="skin === 'icam-red'?'duplicate-documentation.text-init-2-simple':'duplicate-documentation.text-init-2'">_... o explora tus implantaciones paso a paso.</p>
            <button class="duplicate-documentation__explore-link"
              (click)="changeView()">
              <span class="common-button__link-text"
                [afTranslate]="'duplicate-documentation.explore'">_Explorar</span>
            </button>
          </div>
        </div>
      }
      @case ('search') {
        <p class="duplicate-documentation__header-title-container"
          [afTranslate]="'result-search.search-result'">_Resultados de la búsqueda</p>
        <div class="common-search__container">
          <div class="common-search__container-tonal"
            [ngClass]="{'common-search__container-tonal--error': duplicateDocumentation.searchTextError}">
            <div class="common-search__container-input-text">
              <input type="search"
                class="common-search__input-text"
                [(ngModel)]="duplicateDocumentation.searchText"
                placeholder="{{'common.search-item' | afTranslate}}"
                (keydown.enter)="goToPressEnter($event)">
            </div>
            <div class="common-search__block-button-search">
              @if(duplicateDocumentation.searchText){
                <button class="common-button__icon-xs-noborder"
                  (click)="resetSearch()">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
              <div class="h-[22px]"
                [ngClass]="duplicateDocumentation.searchText && duplicateDocumentation.copySearchText !== duplicateDocumentation.searchText?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'"></div>
              <button class="common-button__icon-sm-noborder"
                (click)="goToSearch()"
                [disabled]="!duplicateDocumentation.searchText || duplicateDocumentation.copySearchText === duplicateDocumentation.searchText">
                <i class="lf-icon-search common-icon__md"></i>
              </button>
            </div>
          </div>
          @if(duplicateDocumentation.searchTextError){
            <div class="common-search__container-error">
              <span [afTranslate]="'common.required-3-characters'">_Es necesario introducir al menos 3 caracteres</span>
            </div>
          }
        </div>
        <div class="common-table__container-border">
          <div class="common-table-header__container">
            <div class="common-table-cell__container-p-0 w-[38px]">
              <div class="common-button__block-button-md-checkbox">
                <button class="common-button__icon-md-checkbox"
                  [ngClass]="{'common-button__icon-md-checkbox--selected': duplicateDocumentation.selectAllDocument}"
                  (click)="selectAllDocumentCheckDuplicate()">
                  <i class="common-icon__md"
                    [ngClass]="duplicateDocumentation.selectAllDocument ? 'lf-icon-check-full' : 'lf-icon-box-inactive'">
                  </i>
                </button>
              </div>
            </div>
            <div class="common-table-cell__container w-[60px]">
              <filter-by-list-and-order
                [item]="duplicateDocumentation.extensionFilter"
                [list]="duplicateDocumentation.extensionList"
                (launchActionFilterOrderEmit)="filterOrder($event, 'extension')">
              </filter-by-list-and-order>
            </div>
            <div class="common-table-body__inner-row w-[calc(100%-98px)]">
              <div class="common-table-cell__container"
                [ngClass]="skin === 'icam-red'?'w-[75%]':'w-[25%]'">
                <filter-by-search-and-order
                  [item]="duplicateDocumentation.titleFilter"
                  [filterOrder]="duplicateDocumentation.filterOrder"
                  [order]="duplicateDocumentation.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'Name')">
                </filter-by-search-and-order>
              </div>
              @if (skin !== 'icam-red') {
                <div class="common-table-cell__container w-[25%]">
                  <filter-by-search-and-order
                    [item]="duplicateDocumentation.implantationFilter"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'EvaluationName')">
                  </filter-by-search-and-order>
                </div>
                <div class="common-table-cell__container w-[25%]">
                  <filter-by-search-and-order
                    [item]="duplicateDocumentation.organizationFilter"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'ClientName')">
                  </filter-by-search-and-order>
                </div>
              }
              <div class="common-table-cell__container w-[25%]">
                <filter-by-order
                  [item]="duplicateDocumentation.creationDateFilter"
                  [filterOrder]="duplicateDocumentation.filterOrder"
                  [order]="duplicateDocumentation.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'CreationDate')">
                </filter-by-order>
              </div>
            </div>
          </div>
          <div class="common-table-body__container max-h-[230px]">
            @if(duplicateDocumentation.searchingDocuments){
              <div class="duplicate-documentation__spinner-empty-container">
                <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
                  ariaLabel="loading"></p-progressSpinner>
              </div>
            }@else {
              @for (document of duplicateDocumentation.filterDocumentationList | afOrderBy:duplicateDocumentation.filterOrder:duplicateDocumentation.order | afLimitTo:duplicateDocumentation.configPagination.itemsPerPage:duplicateDocumentation.configPagination.firstElement; track $index) {
               
                   <div class="common-table-body__row"
                  (click)="selectMultipleDocument(document)">
                  <div class="common-table-cell__container-p-0 w-[38px]">
                    <div class="common-button__block-button-md-checkbox">
                      <button class="common-button__icon-md-checkbox"
                        [ngClass]="{'common-button__icon-md-checkbox--selected': document.selectedDocument}">
                        <i class="common-icon__md"
                          [ngClass]="document.selectedDocument ? 'lf-icon-check-full' : 'lf-icon-box-inactive'">
                        </i>
                      </button>
                    </div>
                  </div>
                  <div class="common-table-cell__container-center w-[60px]">
                    <span [class]="'common-icon__md ' + (document.extension | extensionDocument:'md')"></span>
                  </div>
                  <div class="common-table-body__inner-row w-[calc(100%-98px)]">
                    <div class="common-table-cell__container"
                      [ngClass]="skin === 'icam-red'?'w-[75%]':'w-[25%]'">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="document.Name"></span-tooltip>
                    </div>
                    @if (skin !== 'icam-red') {
                      <div class="common-table-cell__container w-[25%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="document.EvaluationName"></span-tooltip>
                      </div>
                      <div class="common-table-cell__container w-[25%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="document.ClientName"></span-tooltip>
                      </div>
                    }
                    <div class="common-table-cell__container w-[25%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="document.CreationDate | convertDate:'without-time'"></span-tooltip>
                    </div>
                  </div>
                </div>
               
              }@empty {
                <div class="duplicate-documentation__spinner-empty-container">
                  <div class="common-empty-state__message-container"
                    [afTranslate]="duplicateDocumentation.NameValue || duplicateDocumentation.EvaluationNameValue  || duplicateDocumentation.ClientNameValue?'new-evaluation.no-results':'new-evaluation.no-results-for-search'">_No hay resultados que coincidan con tu búsqueda</div>
                </div>
              }
            }
          </div>
          @if(!duplicateDocumentation.searchingDocuments && duplicateDocumentation.filterDocumentationList?.length){
            <pagination-control
              [config]="duplicateDocumentation.configPagination"
              [totalRecords]="duplicateDocumentation.filterDocumentationList?.length"
              (currentPageChange)="changeCurrentPage($event)"></pagination-control>
          }
        </div>
      }
      @case ('product') {
        <p class="duplicate-documentation__header-title-container"
          [afTranslate]="skin === 'icam-red'?'duplicate-documentation.explore-deployment':'duplicate-documentation.explore-deployments'">_Explorar implantaciones</p>
        @if (skin !== 'uk-steel-blue') {
          <p-dropdown [options]="duplicateDocumentation.productList"
            [(ngModel)]="duplicateDocumentation.selectedProduct"
            (onChange)="selectProduct()"
            (onShow)="duplicateDocumentation.showProductsFilter = true"
            (onHide)="duplicateDocumentation.showProductsFilter = false"
            [disabled]="!duplicateDocumentation.productList?.length"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            [showClear]="true"
            dropdownIcon="lf-icon-filter-2 common-icon__md"
            class="w-[200px]"
            styleClass="common-dropdown__element-filter"
            panelStyleClass="common-dropdown__element-overlay"
            placeholder="{{'dashboard.product-filter' | afTranslate}}">
            <ng-template pTemplate="filter" let-options="options">
              <div class="common-search__container-tonal">
                <div class="common-search__container-input-text">
                  <input type="search"
                    class="common-search__input-text"
                    [(ngModel)]="duplicateDocumentation.filterProduct"
                    placeholder="{{'common.search-item' | afTranslate}}"
                    (keyup)="options.filter($event)"
                    pAutoFocus
                    [autofocus]="duplicateDocumentation.showProductsFilter">
                </div>
                <div class="common-search__block-button-search">
                  @if(duplicateDocumentation.filterProduct){
                    <button class="common-button__icon-xs-noborder"
                      (click)="resetSearchDropdown(options)">
                      <i class="lf-icon-close-thick common-icon__sm"></i>
                    </button>
                  }
                  <div class="h-[22px]"
                    ngClass="{{duplicateDocumentation.filterProduct?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}"></div>
                  <i class="lf-icon-search common-icon__md"
                    ngClass="{{!duplicateDocumentation.filterProduct?'common-search__icon-search-disabled':'common-search__icon-search-enabled'}}"></i>
                </div>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem">
              <span-tooltip [text]="duplicateDocumentation.selectedProduct.name"
                [tooltipPosition]="'top'"></span-tooltip>
            </ng-template>
            <ng-template pTemplate="clearicon">
              <button class="common-button__icon-xs-noborder">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            </ng-template>
            <ng-template let-product pTemplate="item">
              <button class="common-dropdown-list__si-button-cascade">
                <span class="common-dropdown-list__si-button-inner">
                  <span-tooltip class="common-dropdown-list__si-text-container"
                    [text]="product.name"
                    [tooltipPosition]="'top'"></span-tooltip>
                </span>
              </button>
            </ng-template>
            <ng-template pTemplate="emptyfilter">
              <span class="common-empty-state__searched-text"
                [afTranslate]="'common.without-results'">Sin resultados</span>
            </ng-template>
          </p-dropdown>
        }
        <div class="common-table__container-border">
          <div class="common-table-header__container">
            <div class="common-table-body__inner-row w-[calc(100%-30px)]">
              <div class="common-table-cell__container w-[50%]">
                <filter-by-search-and-order
                  [item]="duplicateDocumentation.implantationFilter"
                  [filterOrder]="duplicateDocumentation.filterOrder"
                  [order]="duplicateDocumentation.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'name')">
                </filter-by-search-and-order>
              </div>
              <div class="common-table-cell__container w-[50%]">
                <filter-by-search-and-order
                  [item]="duplicateDocumentation.organizationFilter"
                  [filterOrder]="duplicateDocumentation.filterOrder"
                  [order]="duplicateDocumentation.order"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'clientName')">
                </filter-by-search-and-order>
              </div>
            </div>
          </div>
          <div class="common-table-body__container max-h-[230px]">
            @if(duplicateDocumentation.searchingEvaluations){
              <div class="duplicate-documentation__spinner-empty-container">
                <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
                  ariaLabel="loading"></p-progressSpinner>
              </div>
            }@else {
              @for (documentEvaluation of duplicateDocumentation.filterEvaluationList | afOrderBy:duplicateDocumentation.filterOrder:duplicateDocumentation.order | afLimitTo:duplicateDocumentation.configPagination.itemsPerPage:duplicateDocumentation.configPagination.firstElement; track $index) {
                <div class="common-table-body__row"
                  (click)="selectEvaluation(documentEvaluation)">
                  <div class="common-table-body__inner-row w-[calc(100%-30px)]">
                    <div class="common-table-cell__container w-[50%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="documentEvaluation.name"></span-tooltip>
                    </div>
                    <div class="common-table-cell__container w-[50%]">
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="documentEvaluation.clientName"></span-tooltip>
                    </div>
                  </div>
                  <div>
                    <button class="common-button__icon-md-noborder">
                      <i class="lf-icon-angle-right common-icon__md"></i>
                    </button>
                  </div>
                </div>
              }@empty {
                <div class="duplicate-documentation__spinner-empty-container">
                  <div class="common-empty-state__message-container"
                    [afTranslate]="'new-evaluation.no-results-for-search'">_No hay resultados que coincidan con tu búsqueda</div>
                </div>
              }
            }
          </div>
          @if(!duplicateDocumentation.searchingEvaluations && duplicateDocumentation.filterEvaluationList?.length){
            <pagination-control
              [config]="duplicateDocumentation.configPagination"
              [totalRecords]="duplicateDocumentation.filterEvaluationList?.length"
              (currentPageChange)="changeCurrentPage($event)"></pagination-control>
          }
        </div>
      }
      @default {
        <!-- case 'folder' -->
        <!-- case 'concept' -->
        <!-- case 'instance' -->
        <p class="duplicate-documentation__header-title-container"
          [afTranslate]="'duplicate-documentation.explore-deployments'">_Explorar implantaciones</p>
        <div class="common-breadcrumb__container">
          <div class="common-breadcrumb__container-all-breadcrumbs">
            @if (duplicateDocumentation.showMoreBreadcrumbs) {
            <div class="common-breadcrumb__block-more">
              <div>
                <button class="common-breadcrumb__button-home"
                  (click)="menuActionBreadcrumbDuplicateDocumentation.toggle($event)">
                  ...
                </button>
                <p-menu #menuActionBreadcrumbDuplicateDocumentation
                  styleClass="common-dropdown-list__a-container"
                  appendTo="body"
                  [model]="duplicateDocumentation.breadcrumbList"
                  [popup]="true">
                  <ng-template pTemplate="action" let-breadcrumb>
                    @if(breadcrumb.hidden){
                      <button class="common-dropdown-list__si-button"
                        (click)="selectBreadcrumb(breadcrumb)">
                        <span-tooltip class="common-dropdown-list__si-text-container"
                          [text]="breadcrumb.nameBreadcrumb"
                          [tooltipPosition]="'top'"
                          [multiline]="2"></span-tooltip>
                      </button>
                    }
                  </ng-template>
                </p-menu>
              </div>
            </div>
            }
            <div class="common-breadcrumb__container-breadcrumbs"
              id="duplicateDocumentationListBreadcrumbs">
              @for (breadcrumb of duplicateDocumentation.breadcrumbList; track $index) {
                @if(!breadcrumb.hidden){
                  <div class="common-breadcrumb__container-element-breadcrumb"
                    [ngStyle]="{'max-width': 100/duplicateDocumentation.breadcrumbList.length + '%'}">
                    @if (!$first) {
                      <span class="common-breadcrumb__icon-arrow">></span>
                    }
                    <span-tooltip class="common-breadcrumb__label-text-breadcrumb"
                      [ngClass]="{'common-breadcrumb__label-text-breadcrumb--selected': $last}"
                      [text]="breadcrumb.nameBreadcrumb"
                      (click)="selectBreadcrumb(breadcrumb, $last)"></span-tooltip>
                  </div>
                }
              }
            </div>
          </div>
        </div>
        @if(duplicateDocumentation.stepState === 'folder'){
          <div class="common-table__container-border">
            <div class="common-table-header__container">
              <div class="common-table-cell__container w-[calc(100%-30px)]">
                <span-tooltip class="common-table-cell__title-text-label"
                  [text]="(duplicateDocumentation.breadcrumbList?.length>2?'duplicate-documentation.folders-and-concepts':'duplicate-documentation.section-menu') | afTranslate">_Menú de apartados/Carpetas y conceptos</span-tooltip>
              </div>
            </div>
            <div class="common-table-body__container max-h-[230px]">
              @if(duplicateDocumentation.searchingTreeEvaluation){
                <div class="duplicate-documentation__spinner-empty-container">
                  <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
                    ariaLabel="loading"></p-progressSpinner>
                </div>
              }@else {
                @for (item of duplicateDocumentation.filterEvaluationTreeList; track $index) {
                  <div class="common-table-body__row"
                    (click)="selectFolder(item, 'list')">
                    <div class="common-table-cell__container w-[calc(100%-30px)]">
                      @if (item.parentId && item.folderId) {
                        <div class="common-icon__md"
                          [ngClass]="item.isFront?'lf-icon-svg-folder-user-md':'lf-icon-svg-folder-md'"></div>
                      }@else {
                        <i class="common-icon__md"
                          [ngClass]="{'lf-icon-folder': item.folderId && !item.isFront,
                            'lf-icon-folder-user': item.folderId && item.isFront,
                            'lf-icon-template-user': item.conceptId && item.isFront,
                            'lf-icon-template': item.conceptId && !item.isFront}"></i>
                      }
                      <span-tooltip class="common-table-cell__standard-text-label"
                        [text]="item.folderId?item.name:item.title"></span-tooltip>
                    </div>
                    <div>
                      <button class="common-button__icon-md-noborder">
                        <i class="lf-icon-angle-right common-icon__md"></i>
                      </button>
                    </div>
                  </div>
                }@empty {
                  <div class="duplicate-documentation__spinner-empty-container">
                    <div class="common-empty-state__message-container"
                      [afTranslate]="'new-evaluation.no-results-for-search'">_No hay resultados que coincidan con tu búsqueda</div>
                  </div>
                }
              }
            </div>
            @if(!duplicateDocumentation.searchingTreeEvaluation && duplicateDocumentation.filterEvaluationTreeList?.length){
              <div class="pagination-control">
                <div class="pagination-control__container-text-pagination">
                  <span class="pagination-control__text-pagination-bold">
                    <span [afTranslate]="'common.total'">_Total</span>:
                    <span>{{duplicateDocumentation.filterEvaluationTreeList.length}}</span>
                  </span>
                </div>
              </div>
            }
          </div>
        }@else if(duplicateDocumentation.stepState === 'concept'){
          @switch (duplicateDocumentation.viewConceptTable) {
            @case ('Usuario') {
              <duplicate-documentation-collegiate
                [filterConceptList]="duplicateDocumentation.filterConceptList"
                [duplicateDocumentation]="duplicateDocumentation"
                (sendAction)="launchAction($event)">
              </duplicate-documentation-collegiate>
            }
            @case ('Digitalizacion') {
              <duplicate-documentation-digitization
                [filterConceptList]="duplicateDocumentation.filterConceptList"
                [duplicateDocumentation]="duplicateDocumentation"
                (sendAction)="launchAction($event)">
              </duplicate-documentation-digitization>
            }
            @case ('Publicacion') {
              <duplicate-documentation-publication
                [filterConceptList]="duplicateDocumentation.filterConceptList"
                [duplicateDocumentation]="duplicateDocumentation"
                (sendAction)="launchAction($event)">
              </duplicate-documentation-publication>
            }
            @case ('Consulta') {
              <duplicate-documentation-query
                [filterConceptList]="duplicateDocumentation.filterConceptList"
                [duplicateDocumentation]="duplicateDocumentation"
                (sendAction)="launchAction($event)">
              </duplicate-documentation-query>
            }
            @default {
              <duplicate-documentation-step
                [filterConceptList]="duplicateDocumentation.filterConceptList"
                [duplicateDocumentation]="duplicateDocumentation"
                (sendAction)="launchAction($event)">
              </duplicate-documentation-step>
            }
          }
        }@else if(duplicateDocumentation.stepState === 'instance'){
          <div class="common-table__container-border">
            <div class="common-table-header__container">
              <div class="common-table-cell__container-p-0 w-[38px]">
                <div class="common-button__block-button-md-checkbox">
                  <button class="common-button__icon-md-checkbox"
                    [ngClass]="{'common-button__icon-md-checkbox--selected': duplicateDocumentation.selectAllDocument}"
                    (click)="selectAllDocumentCheckDuplicate()">
                    <i class="common-icon__md"
                      [ngClass]="duplicateDocumentation.selectAllDocument ? 'lf-icon-check-full' : 'lf-icon-box-inactive'">
                    </i>
                  </button>
                </div>
              </div>
              <div class="common-table-cell__container w-[60px]">
                <filter-by-list-and-order
                  [item]="duplicateDocumentation.extensionFilter"
                  [list]="duplicateDocumentation.extensionList"
                  (launchActionFilterOrderEmit)="filterOrder($event, 'extension')">
                </filter-by-list-and-order>
              </div>
              <div class="common-table-body__inner-row w-[calc(100%-128px)]">
                <div class="common-table-cell__container w-[40%]">
                  <filter-by-search-and-order
                    [item]="duplicateDocumentation.titleFilter"
                    [filterOrder]="duplicateDocumentation.filterOrder"
                    [order]="duplicateDocumentation.order"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'name')">
                  </filter-by-search-and-order>
                </div>
                <div class="common-table-cell__container w-[30%]">
                  <filter-by-search-and-order
                    [item]="duplicateDocumentation.createdByFilter"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'createdBy')">
                  </filter-by-search-and-order>
                </div>
                <div class="common-table-cell__container w-[30%]">
                  <filter-by-order
                    [item]="duplicateDocumentation.createdFilter"
                    [filterOrder]="duplicateDocumentation.filterOrder"
                    [order]="duplicateDocumentation.order"
                    (launchActionFilterOrderEmit)="filterOrder($event, 'created')">
                  </filter-by-order>
                </div>
              </div>
            </div>
            <div class="common-table-body__container max-h-[230px]">
              @if(duplicateDocumentation.searchingDocuments){
                <div class="duplicate-documentation__spinner-empty-container">
                  <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
                    ariaLabel="loading"></p-progressSpinner>
                </div>
              }@else {
                @for (document of duplicateDocumentation.filterDocumentationList | afOrderBy:duplicateDocumentation.filterOrder:duplicateDocumentation.order | afLimitTo:duplicateDocumentation.configPagination.itemsPerPage:duplicateDocumentation.configPagination.firstElement; track $index) {
                  <div class="common-table-body__row"
                    (click)="selectMultipleDocument(document)">
                    <div class="common-table-cell__container-p-0 w-[38px]">
                      @if (!document.folderId) {
                        <div class="common-button__block-button-md-checkbox">
                          <button class="common-button__icon-md-checkbox"
                            [ngClass]="{'common-button__icon-md-checkbox--selected': document.selectedDocument}">
                            <i class="common-icon__md"
                              [ngClass]="document.selectedDocument ? 'lf-icon-check-full' : 'lf-icon-box-inactive'">
                            </i>
                          </button>
                        </div>
                      }
                    </div>
                    <div class="common-table-cell__container-center w-[60px]">
                      <span [class]="'common-icon__md ' + (document.folderId?'lf-icon-svg-folder-md':(document.extension | extensionDocument:'md'))"></span>
                    </div>
                    <div class="common-table-body__inner-row w-[calc(100%-128px)]">
                      <div class="common-table-cell__container w-[40%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="document.name"></span-tooltip>
                      </div>
                      <div class="common-table-cell__container w-[30%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="document.createdBy"></span-tooltip>
                      </div>
                      <div class="common-table-cell__container w-[30%]">
                        <span-tooltip class="common-table-cell__standard-text-label"
                          [text]="document.created | convertDate:'without-time'"></span-tooltip>
                      </div>
                    </div>
                    @if (document.folderId) {
                      <div>
                        <button class="common-button__icon-md-noborder">
                          <i class="lf-icon-angle-right common-icon__md"></i>
                        </button>
                      </div>
                    }
                  </div>
                }@empty {
                  <div class="duplicate-documentation__spinner-empty-container">
                    <div class="common-empty-state__message-container"
                      [afTranslate]="duplicateDocumentation.createdByValue || duplicateDocumentation.titleValue?'new-evaluation.no-results':'documentation-list.no-documentation'">_No hay documentación</div>
                  </div>
                }
              }
            </div>
            @if(!duplicateDocumentation.searchingDocuments && duplicateDocumentation.filterDocumentationList?.length){
              <pagination-control
                [config]="duplicateDocumentation.configPagination"
                [totalRecords]="duplicateDocumentation.filterDocumentationList?.length"
                (currentPageChange)="changeCurrentPage($event)"></pagination-control>
            }
          </div>
        }
      }
    }
  </div>
  @if (duplicateDocumentation.stepState === 'init') {
    <div class="common-modal__footer">
      <button class="common-button__text"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.close'">_Cerrar</span>
      </button>
    </div>
  }@else{
    <div class="common-modal__footer">
      <button class="common-button__text-noborder"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text-border"
        (click)="backInit()">
        <span class="common-button__text-title"
          [afTranslate]="'duplicate-documentation.back'">_Volver al inicio</span>
      </button>
      <button class="common-button__text"
        [disabled]="!duplicateDocumentation.documentChecked"
        (click)="importDocuments()">
        <span class="common-button__text-title"
        [afTranslate]="'duplicate-documentation.import'">_Importar</span>
      </button>
    </div>
  }
</div>
